export default __webpack_public_path__ + "static/media/esky.7367286b.svg";